import { Typography } from "antd";
import { useCallback, useMemo } from "react";
import { formatPercentage } from "../../utils/calculations";
import StatisticCard from "../StatisticCard";
import { SalesSummary } from "@/types/report";

interface SalesOverviewProps {
  sales?: SalesSummary;
}

const SalesOverview = ({ sales }: SalesOverviewProps) => {
  // const { data: saleCategories } = useGetSaleCategories();

  const getPercentage = useCallback(
    (final_amount: number) => {
      if (!sales?.final_amount) {
        return "0%";
      }

      const margin = (final_amount / sales.final_amount) * 100;

      return formatPercentage(margin);
    },
    [sales]
  );

  // TODO: wait until backend is ready
  // const salesCategoryStatistics = useMemo(() => {
  //   if (!sales || !saleCategories) {
  //     return [];
  //   }

  //   const statistics = saleCategories.reduce(
  //     (acc: SaleCategoryStatistic[], sc: SaleCategory) => {
  //       const salesCategoryDetail = sales?.details.find(
  //         (scd: SaleCategoryDetail) => scd.category_id === sc.id
  //       );

  //       if (!salesCategoryDetail) {
  //         return acc;
  //       }

  //       return [
  //         ...acc,
  //         {
  //           ...salesCategoryDetail,
  //           percentage: getPercentage(salesCategoryDetail.total_amount),
  //         },
  //       ];
  //     },
  //     []
  //   );

  //   return statistics;
  // }, [sales, saleCategories]);

  const sortedSales = useMemo(
    () => sales?.details.sort((a, b) => b.final_amount - a.final_amount) || [],
    [sales?.details]
  );

  return (
    <>
      <div style={{ gridColumn: "1 / -1" }}>
        <Typography.Title
          level={5}
          style={{ fontWeight: 500, marginBottom: 0 }}
        >
          Sales Overview
        </Typography.Title>
      </div>

      {/* Total sales with tax */}
      <StatisticCard
        type="total"
        title="Total Sales Gross"
        value={sales?.final_amount || 0}
        showPercentage={false}
      />

      {/* Total sales without tax */}
      <StatisticCard
        type="total"
        title="Total Sales Net"
        value={sales?.final_amount_exclude_tax || 0}
        showPercentage={false}
      />

      {sortedSales.map((report) => (
        <StatisticCard
          key={report.category_id}
          title={report.category_name}
          value={report.final_amount}
          percentage={getPercentage(report.final_amount)}
        />
      ))}
    </>
  );
};

export default SalesOverview;
